module.exports = [
  {
    key: 'AMY',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_4',
      defaultIslamicOutfit: 'OUTFIT_4_x_ISLAMIC'
    },
    name: {
      en: 'Amy',
      es: null,
    },
    selectionName: {
      en: 'Female 1',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/AMY-avatar.png',
    },
  },
  {
    key: 'PATRICIA',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_3',
      defaultIslamicOutfit: 'OUTFIT_3_x_ISLAMIC',
    },
    name: {
      en: 'Patricia',
      es: null,
    },
    selectionName: {
      en: 'Female 2',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/PATRICIA-avatar.png',
    },
  },
  {
    key: 'LEAH',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_2',
      defaultIslamicOutfit: 'OUTFIT_2_x_ISLAMIC'
    },
    name: {
      en: 'Leah',
      es: null,
    },
    selectionName: {
      en: 'Female 3',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/LEAH-avatar.png',
    },
  },
  {
    key: 'KIM',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'OBESE',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_1',
      defaultIslamicOutfit: 'OUTFIT_1_x_ISLAMIC'
    },
    name: {
      en: 'Kim',
      es: null
    },
    selectionName: {
      en: 'Female 4',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/KIM-avatar.png'
    },
  },
  {
    key: 'SHERYL',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_2',
      defaultIslamicOutfit: 'OUTFIT_2_x_ISLAMIC'
    },
    name: {
      en: 'Sheryl',
      es: null,
    },
    selectionName: {
      en: 'Female 5',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/SHERYL-avatar.png',
    },
  },
  {
    key: 'BEN',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_3'
    },
    name: {
      en: 'Ben',
      es: null,
    },
    selectionName: {
      en: 'Male 1',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/BEN-avatar.png',
    },
  },
  {
    key: 'JOSHUA',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_4',
    },
    name: {
      en: 'Joshua',
      es: null,
    },
    selectionName: {
      en: 'Male 2',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/JOSHUA-avatar.png',
    },
  },
  {
    key: 'LIAM',
    avatarOptions: {
      bodyType: 'OBESE',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_1'
    },
    name: {
      en: 'Liam',
      es: null
    },
    selectionName: {
      en: 'Male 3',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/LIAM-avatar.png'
    },
  },
  {
    key: 'HAWTHORN',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_2'
    },
    name: {
      en: 'Hawthorn',
      es: null,
    },
    selectionName: {
      en: 'Male 4',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/thumbnails/HAWTHORN-avatar.png',
    },
  },
];